"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEventPool = exports.createQueue = exports.scheduleFlush = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _helpers = require("./common/helpers");

var _storageKeys = require("./storageKeys");

var PAGE_LOADED_TIME = Date.now();
var PAGE_LOAD_DEFER_TIMER = 6000;
var DEBOUNCE_TIMER = 2000;
var SERIALIZED_ARRAY = JSON.stringify([]);
var hasDeferredExecution = false;
var pageHasLoaded = false;

var getTimeSincePageLoad = function getTimeSincePageLoad() {
  return Date.now() - PAGE_LOADED_TIME;
};

var shouldDefer = function shouldDefer() {
  if (pageHasLoaded) {
    return false;
  }

  return getTimeSincePageLoad() < PAGE_LOAD_DEFER_TIMER;
};

var execute = function execute(callback) {
  return callback();
};

var deferredExecution = function deferredExecution() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (hasDeferredExecution) {
    return;
  }

  setTimeout(function () {
    execute.apply(void 0, args);
    pageHasLoaded = true;
  }, PAGE_LOAD_DEFER_TIMER - getTimeSincePageLoad());
  hasDeferredExecution = true;
};

var debouncedExecution = (0, _helpers.debounce)(execute, DEBOUNCE_TIMER);

var scheduleFlush = function scheduleFlush() {
  if (shouldDefer()) {
    deferredExecution.apply(void 0, arguments);
  } else {
    debouncedExecution.apply(void 0, arguments);
  }
};
/*
 * The event pool utilizes a queue under the hood
 * for it's first-in-first-out functionality.
 */


exports.scheduleFlush = scheduleFlush;

var createQueue = function createQueue() {
  var queue = [];
  return {
    enqueue: function enqueue(event) {
      return queue.unshift(event);
    },
    dequeue: function dequeue() {
      return queue.shift();
    },
    peek: function peek() {
      return queue[0];
    }
  };
};

exports.createQueue = createQueue;

var createEventPool = function createEventPool(_ref) {
  var getTempStorage = _ref.getTempStorage,
      setTempStorage = _ref.setTempStorage;
  var isInitialized = false;
  var eventQueue = createQueue();
  return {
    getIsInitialized: function getIsInitialized() {
      return isInitialized;
    },
    initialize: function initialize(_ref2) {
      var normalizeEvent = _ref2.normalizeEvent;

      try {
        var storedEvents = getTempStorage(_storageKeys.storageKey) || SERIALIZED_ARRAY;
        var parsedEvents = JSON.parse(storedEvents);

        if (parsedEvents && (0, _helpers.isArray)(parsedEvents)) {
          parsedEvents.forEach(function (event) {
            if (event && (0, _typeof2.default)(event) === 'object') {
              eventQueue.enqueue(normalizeEvent(event));
            }
          });
        }

        isInitialized = true;
      } catch (err) {
        /* noOp */
      }
    },
    push: function push(event) {
      try {
        var storedEvents = getTempStorage(_storageKeys.storageKey) || SERIALIZED_ARRAY;
        var parsedEvents = JSON.parse(storedEvents);
        parsedEvents.push(event);
        setTempStorage(_storageKeys.storageKey, JSON.stringify(parsedEvents));
      } catch (err) {
        /* noOp */
      }

      eventQueue.enqueue(event);
    },
    flush: function flush() {
      var events = [];

      do {
        var event = eventQueue.dequeue();

        if (event) {
          events.unshift(event);
        }
      } while (eventQueue.peek());

      try {
        setTempStorage(_storageKeys.storageKey, SERIALIZED_ARRAY);
      } catch (err) {
        /* noOp */
      }

      return events;
    },
    peek: eventQueue.peek
  };
};

exports.createEventPool = createEventPool;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.376/js/eventPool.js
// module id = 232
// module chunks = 0